module.exports = __webpack_public_path__ + "img/award.8f0894fb.svg";